export default __webpack_public_path__ + "static/media/2waveMotion.2694cc22.svg";